"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @param {String} params.key - e.g. "1 DAY" - should always be upperCase
 * @param {Boolean} params.showToCustomers
 * @param {Boolean} params.active
 * @param {String} params.text - "Super Rush: $100"
 * @param {Number} params.value - cost in dollars (eg. 100)
 */
var PrintingOption = function PrintingOption() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  _classCallCheck(this, PrintingOption);

  this.key = params.key && params.key.toUpperCase();
  this.showToCustomers = params.showToCustomers;
  this.active = params.active;
  this.text = params.text;
  this.altText = params.altText;
  this.description = params.description;
  this.value = params.value;
};

module.exports = PrintingOption;